import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadSharedPlansAction,
  ILoadSharedPlansSuccessAction,
  LoadSharedPlansErrorAction,
} from '../actions/load-shared-fairplay-plans'
import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadSharedPlansAction =
  | ILoadSharedPlansAction
  | ILoadSharedPlansSuccessAction
  | LoadSharedPlansErrorAction

const init = (state: IMobilityState, action: LoadSharedPlansAction) => ({
  ...state,
  sharedplans: {
    ...initialState.sharedplans,
    status: action.status,
  },
})

const success = (state: IMobilityState, action: LoadSharedPlansAction) => ({
  ...state,
  sharedplans: {
    ...initialState.sharedplans,
    status: action.status,
    data: (action as ILoadSharedPlansSuccessAction).data,
    payload: (action as ILoadSharedPlansSuccessAction).payload,
  },
})

const reset = (state: IMobilityState, action: LoadSharedPlansAction) => ({
  ...state,
  sharedplans: {
    ...initialState.sharedplans,
    status: action.status,
    data: null,
    error: null,
  },
})

const failure = (state: IMobilityState, action: LoadSharedPlansAction) => ({
  ...state,
  sharedplans: {
    ...initialState.sharedplans,
    status: action.status,
    error: (action as LoadSharedPlansErrorAction).error,
    code: (action as LoadSharedPlansErrorAction).code,
  },
})

export const loadSharedPlansReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
  reset,
)
